import coverPhoto from '../assets/hotspot/celebrationCover/Nowruz.jpg';
import mehramImage from '../assets/hotspot/headerImages/mehram-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/azizam_to_golakami_learn.jpg';
import celebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/Mehrnam_concert.jpg.jpeg';

export const nowruz = {
  celebrationTitle: 'Nowruz',
  startDate: '03-20',
  endDate: '03-20',
  filterValue: 'nowruz',
  displayDate: 'March 20',
  celebrationImage: coverPhoto,
  description: 'Nowruz is the Persian New Year, celebrated by Iranian people and people around the globe. Nowruz always falls within a few days of the northern hemisphere\'s spring equinox. Iranians typically celebrate Nowruz with gift exchanges, fire and dance rituals, and poetry recitations.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105194766?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'Azizam To Golakami',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Nowruz',
        },
      ],
      songDescription: '"Azizam To Golakami" ("My Dear, My Flower") is a traditional Kurdish folk song that originates from the Kurdish region of Iran. The song reflects the intimate connection between people and the natural world, focusing on the beauty of natures, especially flowers.',
    },
    {
      videoLink: 'https://vimeo.com/1105196690?fl=pl&fe=vl',
      videoImage: celebrationThumbnail2,
      songTitle: 'Azizam To Golakami',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Nowruz',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Mehrnam',
      artistImage: mehramImage,
    },
  ],
};
